export default __webpack_public_path__ + "static/get-new-car-image-3-mobile-5d25112b5c7cd0d82696d9c52ce4452c.jpg";